import React from 'react';
import logo from '../assets/logo.png';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex items-center">

        <img src={logo} alt="Tapeat Logo" className="w-12 h-12" />
        <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
          Tapeat
        </span>

      </div>
    </div>
  );
};

export default Logo;